import { DialogConfig } from '../../common/models';
import { put, take } from 'redux-saga/effects';
import { commonActions } from '../../common';

export default function* takeConfirmation(config: DialogConfig) {
  yield put(commonActions.showDialog(config));
  const confirmed: ReturnType<typeof commonActions.hideDialog> = yield take(commonActions.hideDialog);
  return confirmed.payload;
}
